import OnlineAppComponent from "../../../lib/online_app_component";
import iconCrossSvg from './assets/icon__cross.svg';

export const AuxHeaderCloserConfig = {
    baseHtmlClass: 'online_app__aux__header__closer',
    closeboxSvg: iconCrossSvg
}

export class AuxHeaderCloser extends OnlineAppComponent {

    constructor(onlineAppAuxHeader) {
        super(null, onlineAppAuxHeader.onlineApp, AuxHeaderCloserConfig);
        this.element = AuxHeaderCloser.createElement(AuxHeaderCloserConfig.baseHtmlClass);
        this.auxHeader = onlineAppAuxHeader;
        this.element.addEventListener('click', this.handleClick.bind(this));
        this.renderInitial();
    }

    handleClick(event) {
        this.dispatchAction('auxHeaderCloserSelected', this);
    }

    renderInitial() {
        this.element.innerHTML = AuxHeaderCloserConfig.closeboxSvg;
    }

}
